module.exports = __webpack_public_path__ + "img/jiuzhang-back-two@3x.e236f101.jpg";